import { string } from "yup";
import { validationMessages } from "./validationMessages";

export const emailValidationSchema = string().email(
  validationMessages.invalidEmail
);
